import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "container",
  style: {"margin-top":"80px","padding-top":"40px"}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-6 text-right align-self-end" }
const _hoisted_4 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_5 = { class: "table table-bordered table-hover" }
const _hoisted_6 = { class: "dropdown" }
const _hoisted_7 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]

import { computed, onMounted, watch, shallowReactive, Ref } from 'vue'
    import { useRoute } from 'vue-router'
    import { guid } from '@common/Guid'
    import CorporateNavigation from '@common/Components/CorporateNavigation.vue'
    import CapexAccountEditor from '@Quest/Capex/Components/CapexAccountEditor.vue'
    import type { CapexAccountEditorFormSubmitEventPayload } from '@Quest/Capex/Components/CapexAccountEditor'
    import { CapexAccountEditorViewModel } from '@Quest/Capex/Components/CapexAccountEditor'
    import type { CapexAccountReadModel, CapexAccountsReadModel } from '@Quest/Capex/readmodels'
    import { useCapexAccountsByStrategyIdQueryV1 } from '@Quest/Capex/queries-vue-composables'

    import {useCreateCapexAccountCommandV1, useUpdateCapexAccountCommandV1, useDeleteCapexAccountCommandV1} from '@Quest/Capex/commands-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CapexPage',
  setup(__props) {

    const route = useRoute()

    const workspaceId = computed(() => Number(route.params.workspaceId ?? 0))
    const strategyId = computed(() => String(route.params.strategyId ?? ''))

    const capexAccountEditor = shallowReactive(new CapexAccountEditorViewModel())

    const {
        runCapexAccountsByStrategyIdQueryV1,
        modelCapexAccountsByStrategyIdQueryV1
    } = useCapexAccountsByStrategyIdQueryV1(workspaceId, strategyId)

    const rm = modelCapexAccountsByStrategyIdQueryV1 as Ref<CapexAccountsReadModel | null>

    const {
        invokeCreateCapexAccountCommandV1,
        succeedCreateCapexAccountCommandV1
    } = useCreateCapexAccountCommandV1(workspaceId, strategyId)

    const {
        invokeUpdateCapexAccountCommandV1,
        succeedUpdateCapexAccountCommandV1
    } = useUpdateCapexAccountCommandV1(workspaceId, strategyId)

    const {
        invokeDeleteCapexAccountCommandV1,
        succeedDeleteCapexAccountCommandV1
    } = useDeleteCapexAccountCommandV1(workspaceId, strategyId)

    watch(
        [
            succeedCreateCapexAccountCommandV1,
            succeedUpdateCapexAccountCommandV1,
            succeedDeleteCapexAccountCommandV1
        ],
        ([create, update, del], [prevCreate, prevUpdate, prevDel]) =>
        {
            if (
                (create && !prevCreate) ||
                (update && !prevUpdate) ||
                (del && !prevDel)
            )
            {
                runCapexAccountsByStrategyIdQueryV1()
                capexAccountEditor.close()
            }
        }
    )

    function showCapexCreator()
    {
        capexAccountEditor.showCreator()
    }

    function showCapexEditor(c: CapexAccountReadModel)
    {
        capexAccountEditor.showEditor(
            c.Id,
            c.Name,
            c.Description,
            c.Classification
        )
    }

    function handleCapexAccountEditorFormSubmit(
        e: CapexAccountEditorFormSubmitEventPayload
    )
    {
        if (e.id == null)
        {
            invokeCreateCapexAccountCommandV1({
                id: guid(),
                name: e.name,
                description: e.description,
                classification: e.classification
            })
        } else
        {
            invokeUpdateCapexAccountCommandV1({
                id: e.id,
                name: e.name,
                description: e.description,
                classification: e.classification
            })
        }
    }

    function handleDeleteCapexAccountCommand(capex: CapexAccountReadModel)
    {
        if (confirm("Are you sure?"))
        {
            invokeDeleteCapexAccountCommandV1({
                id: capex.Id
            })
        }
    }

    onMounted(() =>
    {
        document.title = "Capex | TransparentChoice"
        runCapexAccountsByStrategyIdQueryV1()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(CapexAccountEditor, {
      viewModel: _unref(capexAccountEditor),
      onFormSubmit: handleCapexAccountEditorFormSubmit
    }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(CorporateNavigation, { ActivePage: "strategy" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-lg-6" }, [
          _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }, "Capex")
        ], -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            role: "button",
            class: "btn btn-success",
            style: {"padding":"0.7em 2em"},
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showCapexCreator()))
          }, "Create capex")
        ])
      ]),
      _cache[6] || (_cache[6] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
      (_unref(rm))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Capex"),
                  _createElementVNode("th", { style: {"width":"120px"} }, "P&L depreciation"),
                  _createElementVNode("th", { style: {"width":"120px"} })
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rm).Accounts, (c) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: c.Id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("strong", null, _toDisplayString(c.Name), 1 /* TEXT */),
                      _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                      _createTextVNode(_toDisplayString(c.Description), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(c.Classification), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_6, [
                        _cache[4] || (_cache[4] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, " Actions ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (showCapexEditor(c))
                          }, "Edit", 8 /* PROPS */, _hoisted_8),
                          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (handleDeleteCapexAccountCommand(c))
                          }, "Delete", 8 /* PROPS */, _hoisted_9)
                        ])
                      ])
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

})